export enum IconName {
  Auction = 'auction',
  Collector = 'collector',
  CollectorFilled = 'collectorFilled',
  Colon = 'colon',
  Promotion = 'promotion',
  WarningEmpty = 'warningEmpty',
  CalendarDateRange = 'calendarDateRange',
  Add = 'add',
  Bag = 'bag',
  ArrowDown15 = 'arrowDown15',
  ArrowUp15 = 'arrowUp15',
  ArrowLeft15 = 'arrowLeft15',
  ArrowRight15 = 'arrowRight15',
  ArrowLeft25 = 'arrowLeft25',
  ArrowRight25 = 'arrowRight25',
  ArrowRightSideRight = 'arrowRightSideRight',
  Check = 'check',
  Close = 'close',
  Delivery = 'delivery',
  Favourite = 'favourite',
  Filter = 'filter',
  Image = 'image',
  Logout = 'logout',
  Loupe = 'loupe',
  Money = 'money',
  Settings = 'settings',
  Store = 'store',
  User = 'user',
  Zl = 'zl',
  CloseSmaller = 'closeSmaller',
  FavouriteFilled = 'favouriteFilled',
  Menu = 'menu',
  Delete = 'delete',
  AddLines = 'addLines',
  Alien = 'alien',
  Danger = 'danger',
  AddCircleOutline = 'addCircleOutline',
  AddOutline = 'addOutline',
  Photo = 'photo',
  LeftArrow = 'leftArrow',
  SettingsFilled = 'settingsFilled',
  MoreVertical = 'moreVertical',
  MoreHorizontal = 'moreHorizontal',
  Receipt = 'receipt',
  PublicProfile = 'publicProfile',
  Gavel = 'gavel',
  Exit = 'exit',
  Equalizer = 'equalizer',
  Dollar = 'dollar',
  Content = 'content',
  Brush = 'brush',
  Account = 'account',
  Warning = 'warning',
  Sort = 'sort',
  InsertLink = 'insertLink',
  Edit = 'edit',
  Download = 'download',
  Description = 'description',
  CheckCircle = 'checkCircle',
  Cancel = 'cancel',
  CloseSmallest = 'closeSmallest',
  InfoIcon = 'infoIcon',
  Card = 'card',
  Cash = 'cash',
  Archive = 'archive',
  Block = 'block',
  Visibility = 'visibility'
}
